<template>
  <div class="jmm-gradient">
  </div>
  <div>
    <headerInc ref="header"/>
    <router-view @adjust-margin="offsetMainContent"></router-view>
    <footerInc />
  </div>
</template>

<script>
	import headerInc from "./components/header.vue";
	import footerInc from "./components/footer.vue";
	export default {
		name: "App",
		components: {
			headerInc,
			footerInc
		},
		mounted() {
			// Wait for everything to render after initial page load
			this.$nextTick(() => {
				// Small delay in case <router-view> needs time to mount
				setTimeout(() => {
				this.offsetMainContent();
				}, 0);
			});

			window.addEventListener("resize", this.offsetMainContent);

			this.$router.afterEach(() => {
				this.$nextTick(() => {
					this.offsetMainContent();
				});
			});
		},
		beforeUnmount() {
			window.removeEventListener("resize", this.offsetMainContent);
		},
		methods: {
			offsetMainContent(extraMargin = 50) {
				const header = this.$refs.header?.$refs.nav;
				const main = document.querySelector(".container");
				if (header && main) {
				const height = header.offsetHeight;
				main.style.marginTop = `${height + extraMargin}px`;
				}
			},
		},
	};
</script>